import { StaffCompletedOrdersTable } from "./StaffCompletedOrdersTable";
import { StaffOrdersTable } from "./StaffOrdersTable";
import { StaffDraftOrdersTable } from "./StaffDraftOrdersTable";
import { StaffEntitlementTable } from "./StaffEntitlementTable";
import { StaffSizesTable } from "./StaffSizesTable";

import { Loading } from "../../components/Loading";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export const StaffCardDetail = ({ staffDetail, loading }) => {
  return (
    <>
      {!loading ? (
        <Stack spacing={3}>
          <Typography variant="h6" component="h2">
            Completed Orders
          </Typography>
          <StaffCompletedOrdersTable
            data={staffDetail?.completedOrders || []}
          />
          <Typography variant="h6" component="h2">
            Current Orders
          </Typography>
          <StaffOrdersTable data={staffDetail?.orders || []} />
          <Typography variant="h6" component="h2">
            Draft Orders
          </Typography>
          <StaffDraftOrdersTable data={staffDetail?.draftOrders || []} />
          <Typography variant="h6" component="h2">
            Entitlement
          </Typography>
          <StaffEntitlementTable data={staffDetail?.entitlement || []} />
          <Typography variant="h6" component="h2">
            Sizes
          </Typography>
          <StaffSizesTable data={staffDetail?.staffsizes || []} />
        </Stack>
      ) : (
        <Loading />
      )}
    </>
  );
};
